<div class="page-outer-wrapper">

  <div class="admin-page-header">
    <div class="hamburger">
      <img (click)="toggleSidebar()" style="cursor: pointer;" src="/assets/images/menu-512.png" height="28" width="28">
    </div>
    <div id="nav-bar" class="nav-bar">
    </div>
  </div>

  <div class="page-content-background">

    <div class="page-content">

      <mat-sidenav-container id="admin-content-wrapper" class="admin-content-wrapper">

        <mat-sidenav #adminsidenav class="admin-sidebar">

          <admin-sidebar></admin-sidebar>

        </mat-sidenav>

        <mat-sidenav-content>

          <!-- [START] page content -->

          <mat-card style="width: 100%; display: block;">

            <mat-card-header>
              <mat-card-title>Organizations</mat-card-title>
            </mat-card-header>

            <mat-card-content style="padding-left: 16px;">

              <p style="width: 650px;">To create a new Organization use the Create input below.
                Note that organizations require a unique key and a name.  The unique key can start with A-Z,
                and the rest of the key can be _, A-Z, or 0-9.</p>

              <div>
                <p-inputgroup>

                  <input style="width: 80px;" (keyup)="checkKey()" id="createorganizationkey" type="text" pInputText placeholder="Key">

                  <input style="width: 200px;" (keyup)="checkKey($event)" id="createorganization" type="text" pInputText placeholder="New Organization">

                  <p-button
                    style="height: 32px;"
                    (click)="createOrganization()"
                    type="button"
                    pButton
                    pRipple
                    icon="pi pi-check"
                    [class.p-button-danger]="!orgInputValid"
                    [class.p-button-success]="orgInputValid"
                  >
                  </p-button>

                </p-inputgroup>
                <div>
                  <p class="orgcreateerror"></p>
                </div>
              </div>

              <p style="width: 650px;">You can manage existing organizations by updating the name or soft deleting.
                To change the name, just click the name and edit inline.  To jump to the organization page, click
                the organization key.  To jump to an organization admin's profile page, click their email address.
              </p>

              <p-table  class="admin-dark-table" selectionMode="single"  sortField="name"  [value]="organizations" (sortFunction)="tableSort($event)" [customSort]="true">

                <ng-template pTemplate="header">
                  <tr style="background-color: #2D323D;">
                    <th width="80" pSortableColumn="id">ID<p-sortIcon field="id"></p-sortIcon></th>
                    <th pSortableColumn="key" style="width: 100px;">KEY<p-sortIcon field="key"></p-sortIcon></th>
                    <th pSortableColumn="name">Name<p-sortIcon field="name"></p-sortIcon></th>
                    <th style="width: 100px;">Status</th>
                    <th style="width: 200px;">Admins</th>
                    <th style="width: 100px;"># Proj</th>
                    <th style="width: 100px;"># Subs</th>
                    <th style="width: 200px;" pSortableColumn="created_at">Created<p-sortIcon field="created_at" ></p-sortIcon></th>
                    <th style="width: 90px;">Actions</th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-org>

                  <tr [className]="'userListrowWrapper'" >

                    <!-- OID -->

                    <td style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;">{{org.id}}</td>

                    <!-- key -->

                    <td style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;">
                      <span class="orglist-key-span"><a href="organization/{{org.key}}">{{org.key}}</a></span>
                    </td>

                    <!-- name -->

                    <td style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;">

                      <!-- allow inline editing on the name -->

                      <p-inplace
                        #component
                        class="orgclass-{{org.id}}"
                        closable="closable"
                        (onDeactivate)="orgEditDeactivate(org.id, component)"
                        (onActivate)="orgEditActivate(org.id, component)"
                        (keyup)="orgEditKey($event, org.id, component)">
                        <ng-template pTemplate="display">
                          {{ org.name }}
                        </ng-template>
                        <ng-template pTemplate="content">
                          <input type="text" value="{{org.name}}" pInputText>
                        </ng-template>
                      </p-inplace>

                    </td>

                    <!-- status -->

                    <td style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;">

                      <div *ngIf="org.is_deleted; then thenDeleted"></div>

                      <ng-template #thenDeleted>
                        <p-tag *ngIf="org.is_deleted" severity="danger" value="Deleted" class="userlisttag"></p-tag>
                      </ng-template>

                    </td>

                    <!-- admins -->

                    <td style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;">

                      <span
                        class="orglist-email-span"
                        *ngFor="let admin of org.admins">
                        <a href="users/{{admin.key}}">{{admin.email}}</a>
                      </span>

                    </td>

                    <!-- usage metrics -->

                    <td>{{org.projects.length}}</td>
                    <td>{{org.subdivisions.length}}</td>

                    <!-- inception -->

                    <td style="font-size: 10px; overflow: hidden; text-overflow: ellipsis;">{{org.created_at}}</td>

                    <!-- available actions -->

                    <td style="font-size: 10px;">

                      <div *ngIf="org.is_deleted; then thenBlock else elseBlock"></div>

                      <ng-template #thenBlock>

                        <!-- if the user was deleted, the ONLY thing you can do is undelete them. -->

                        <a class="useractionicon" (click)="unDeleteOrganization(org.id)">
                          <img width="16" title="Activate" src="assets/images/undelete-64.png">
                        </a>

                      </ng-template>

                      <ng-template #elseBlock>

                        <!-- soft delete (but only if no usage) -->

                        <a *ngIf="canDelete(org.id)" class="useractionicon" (click)="deleteOrganization(org.id)">
                          <img width="16" title="Soft Delete" src="assets/images/delete-64.png">
                        </a>

                      </ng-template>

                    </td>

                  </tr>

                </ng-template>

              </p-table>

            </mat-card-content>

          </mat-card>

        </mat-sidenav-content>

      </mat-sidenav-container>

    </div>

    <div id="pano-footer" class="pano-footer"></div>

  </div>

</div>
